import { useLocation } from "react-router";
import { motion } from "framer-motion";
import useProductLicenseForm from "core/hooks/useProductLicenseForm";
import Error from "core/components/Error";
import DeploymentReview from "modules/admin/OrgProductLicenseForm/DeploymentReview";
import {
  PRODUCT_BUNDLES,
  defaultLicenseState,
} from "modules/admin/OrgProductLicenseForm/constants";
import { deepMergeObjects } from "modules/admin/OrgProductLicenseForm/utilities";

const ProductLicenseConfirmPage = () => {
  const location = useLocation();
  const {
    formState,
    productLicenseMutation,
    licenseDeployment,
    productLicenses,
    catalogError,
    isLoadingLicenses,
    isLoadingCatalog,
    isLoadingSegments,
  } = useProductLicenseForm();

  const {
    getAllProducts,
    getProductIdsEnabled,
    getDynamicProduct,
    getPreparedLicenses,
    updatedProducts,
    filteredBundles,
  } = formState;

  const isLocationFromRoute = location?.state?.from === "route";
  const isFormLoading =
    isLoadingLicenses || isLoadingCatalog || isLoadingSegments;
  const error = catalogError || productLicenseMutation.error;

  const handleSubmit = () => {
    const preparedUpdates = getPreparedLicenses();

    if (preparedUpdates) {
      productLicenseMutation.mutate({
        products: preparedUpdates.products,
      });
    }
  };

  return (
    <motion.div
      initial={{
        opacity: isLocationFromRoute ? 0 : 1,
        y: isLocationFromRoute ? 20 : 0,
      }}
      exit={{
        opacity: 0,
        y: 20,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        opacity: {
          duration: 0.4,
        },
        y: {
          duration: 0.3,
        },
      }}
      data-test="deployment-review"
    >
      <Error style={{ marginBottom: "10px" }}>{error}</Error>

      <DeploymentReview
        bundles={PRODUCT_BUNDLES}
        products={getAllProducts()}
        productsEnabled={getProductIdsEnabled()}
        getDynamicProduct={getDynamicProduct}
        handleSubmit={handleSubmit}
        isSubmitting={productLicenseMutation.isPending}
        isDisabled={!getPreparedLicenses()}
        isLoading={isFormLoading}
        previousData={deepMergeObjects(defaultLicenseState, productLicenses)}
        updatedProducts={updatedProducts}
        filteredBundles={filteredBundles}
        deploymentStatus={licenseDeployment?.status}
      />
    </motion.div>
  );
};

export default ProductLicenseConfirmPage;
